(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lim-purchase-guide"] && !Shopify.designMode) return;
  try {
    const pairLimSizeCardsWithDrawings = () => {
    document.querySelectorAll('.lim-mv .size-guide').forEach((guide) => {
      if (guide.querySelector('.lim-size-pair-grid')) {
        return;
      }

      const sizeGrid = guide.querySelector(':scope > .size-grid');
      const drawingGrid = guide.querySelector(':scope > .drawing-grid');

      if (!sizeGrid || !drawingGrid) {
        return;
      }

      const sizeCards = Array.from(sizeGrid.querySelectorAll(':scope > .size-card'));
      const drawingCards = Array.from(drawingGrid.querySelectorAll(':scope > .drawing-card'));

      if (sizeCards.length !== 2 || drawingCards.length !== 2) {
        return;
      }

      const pairGrid = document.createElement('div');
      pairGrid.className = 'lim-size-pair-grid';

      sizeCards.forEach((sizeCard, index) => {
        const pair = document.createElement('div');
        pair.className = 'lim-size-pair';
        pair.append(sizeCard, drawingCards[index]);
        pairGrid.append(pair);
      });

      sizeGrid.replaceWith(pairGrid);
      drawingGrid.remove();
    });
  };

  const addLimStickyExtras = () => {
    const template = document.querySelector('#lim-sticky-extras-template');

    if (!template) {
      return;
    }

    document.querySelectorAll('product-quick-add').forEach((bar) => {
      if (bar.querySelector('.lim-sticky-extras')) {
        return;
      }

      const mobileBuyButtons = Array.from(bar.children).find((element) => element.matches('buy-buttons'));

      if (mobileBuyButtons) {
        mobileBuyButtons.before(template.content.cloneNode(true));
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      pairLimSizeCardsWithDrawings();
      addLimStickyExtras();
    }, { once: true });
  } else {
    pairLimSizeCardsWithDrawings();
    addLimStickyExtras();
  }

  new MutationObserver(() => {
    pairLimSizeCardsWithDrawings();
    addLimStickyExtras();
  }).observe(document.documentElement, { childList: true, subtree: true });
  } catch(e) { console.error(e); }
})();

})();
